export const EXCMUSERDATASTATUS_SHOW_RESET = 'EXCMUSERDATASTATUS_SHOW_RESET'
export const EXCMUSERDATASTATUS_SHOW_SET_ERROR = 'EXCMUSERDATASTATUS_SHOW_SET_ERROR'
export const EXCMUSERDATASTATUS_SHOW_SET_RETRIEVED = 'EXCMUSERDATASTATUS_SHOW_SET_RETRIEVED'
export const EXCMUSERDATASTATUS_SHOW_TOGGLE_LOADING = 'EXCMUSERDATASTATUS_SHOW_TOGGLE_LOADING'
